import { render, staticRenderFns } from "./Departaments-table.vue?vue&type=template&id=8f45b46a"
import script from "./Departaments-table.vue?vue&type=script&lang=js"
export * from "./Departaments-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports